// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalWrapper_backdrop__LYbLb","modalWrapper":"ModalWrapper_modalWrapper__KcT8E"};